import axios from 'axios'
import store from '@/store'
import Client from '@/apis/liff/Order'
import IntendedRoute from '@/utils/liff/IntendedRoute'
import { getMeta, processLiffState } from './helpers'

const PATH_PATTERN = '%s/liff/group-buying/order-list%s'
const ROUTE_PORTAL = 'LiffOrderPortal'
const ROUTE_ORDERS = 'LiffOrders'
const ROUTE_AUTH_BIND = 'LiffOrderAuthBind'

function tokenProvider () {
  return store.getters['liffOrder/token']
}

async function liffInitializer () {
  await store.dispatch('liffOrder/removeToken')
  await store.dispatch('liffOrder/init')
}

export default async function liffOrder({ next, from, to }) {
  const meta = getMeta(to)
  const orgCode = to.params.orgCode
  //這個要用orders 給api的路由
  const baseURL = `${process.env.VUE_APP_API_BASE_URL}/${orgCode}/liff/orders`

  console.debug(`navigated to: ${to.fullPath}`)

  store.commit('liffOrder/SET_API_BASE_URL', baseURL)

  if (to.query['liff.state']) {
    return processLiffState({ to, next, orgCode, pathPattern: PATH_PATTERN })
  }

  if (to.name === ROUTE_PORTAL) {
    return next({ name: ROUTE_ORDERS, params: { orgCode } })
  }

  if (!Client.instance) {
    await Client.init({ axios, baseURL, tokenProvider, liffInitializer })
  }

  await store.dispatch('liffOrder/fetchUser')

  const user = store.getters['liffOrder/user']

  if (from.name === to.name) {
    return next()
  }


  if (meta.boundOnly && !user.isBound()) {
    IntendedRoute.set(to)

    return next({ name: ROUTE_AUTH_BIND, params: { orgCode } })
  }

  if (meta.notBoundOnly && user.isBound()) {
    return next({ name: ROUTE_ORDERS, params: { orgCode } })
  }

  return next()
}
